"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyPickupEligibility = verifyPickupEligibility;
const interface_1 = require("../interface");
function verifyPickupEligibility(order) {
    if (!order) {
        return interface_1.PickupEligibilityStatus.Error;
    }
    if (order.isDelivered) {
        return interface_1.PickupEligibilityStatus.AlreadyPickedUp;
    }
    if (order.paymentStatus !== interface_1.PaymentStatus.Success) {
        return interface_1.PickupEligibilityStatus.NotPaid;
    }
    if (order.status === interface_1.OrderStatus.Delivered) {
        return interface_1.PickupEligibilityStatus.AlreadyPickedUp;
    }
    if (order.pickupDispute !== interface_1.OrderPickUpDispute.None) {
        return interface_1.PickupEligibilityStatus.DisputeExists;
    }
    return interface_1.PickupEligibilityStatus.Eligible;
}
//# sourceMappingURL=pickup.js.map